// extracted by mini-css-extract-plugin
module.exports = {"tooltipIcon":"TooltipIcon_tooltipIcon__2yoz7","top":"TooltipIcon_top__1ttG4","left":"TooltipIcon_left__2pkVd"};